import { Dispatch } from "../../../../../core";

const dispatchProductPreCancellation = {
  hasDisabledInput: (): boolean => false,
  columns: [
    {
      title: 'Despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: Dispatch) => element.dispatchId
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.skuCode + '-' + element.dispatchItems.skuPartialSequence
    },
    {
      title: 'Descripción',
      name: 'skuName',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.skuName
    },
    {
      title: 'Cant. Total',
      name: 'pendingAmount',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.pendingAmount + ((element.dispatchItems.canceledAmount != null) ? element.dispatchItems.canceledAmount : 0)
    },
    {
      title: 'Cant. Cancelada',
      name: 'canceledAmount',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => (element.dispatchItems.canceledAmount != null) ? element.dispatchItems.canceledAmount : 0
    },
    {
      title: 'Cant. faltante',
      name: 'processedAmount',
      type: 'number',
      editable: true,
      align: 'center',
      placeholderHidden: true,
      value: (element: any) => {
        return { num: element.dispatchItems.processedAmount, min: 1, max: element.dispatchItems.pendingAmount }
      }
    },
    {
      title: 'Motivo de Pre-cancelación',
      name: 'reason',
      type: 'select',
      editable: true,
      class: 'center',
      placeholderHidden: true,
      value: (element: any) =>  element.listMotive ? element.listMotive : []
    }
  ]
}
export { dispatchProductPreCancellation };
